var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSpace48Line = function SvgIconSpace48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 26.44c-.43 0-.86-.1-1.26-.29l-11.8-5.67a2.884 2.884 0 0 1-1.64-2.61c0-1.12.63-2.13 1.65-2.61l11.8-5.67c.8-.38 1.71-.38 2.51 0l11.8 5.67c1.01.49 1.64 1.49 1.64 2.61 0 1.12-.63 2.13-1.65 2.61l-11.8 5.67c-.4.19-.83.29-1.26.29H24Zm-10.65-8.57 10.64 5.11 10.65-5.11-10.65-5.12-10.64 5.12Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 32.64c-.43 0-.86-.1-1.26-.29l-13.33-6.4 1.47-3.06L24 29.19l13.12-6.3 1.47 3.06-13.33 6.4c-.4.19-.83.29-1.26.29Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 38.7c-.43 0-.86-.1-1.26-.29L9.41 32l1.47-3.06L24 35.24l13.12-6.3L38.59 32l-13.33 6.41c-.4.19-.83.29-1.26.29Z",
    fill: "current"
  })));
};
export default SvgIconSpace48Line;